import { RouteRecordRaw } from "vue-router";
import { UserRoleEnum } from "@/app/core/enums/UserRoleEnum";

export const routePrivateOrders: Array<RouteRecordRaw> = [
  {
    path: "orders",
    alias: ["orders", "dispatches"],
    name: "Orders",
    meta: {
      requireAuth: true,
      roles: [UserRoleEnum.Shipper, UserRoleEnum.Carrier, UserRoleEnum.Master],
    },
    redirect: (to) => {
      return { name: "OrdersList" };
    },
    component: () => import("@/app/private/pages/orders/Orders.vue"),
    children: [
      {
        path: "",
        name: "OrdersList",
        component: () =>
          import(
            "@/app/private/pages/orders/OrdersList.vue"
          ),
      },
      {
        path: "accept/:uuid",
        name: "AcceptOrder",
        meta: {
          requireAuth: true,
          roles: [UserRoleEnum.Carrier, UserRoleEnum.Master],
        },
        component: () =>
          import("@/app/private/pages/orders/AcceptOrder.vue"),
      },
      {
        path: ":uuid/accept-load",
        name: "LoadAcceptance",
        meta: {
          requireAuth: true,
          roles: [UserRoleEnum.Carrier, UserRoleEnum.Master],
        },
        component: () =>
          import("@/app/private/pages/orders/OrdersList.vue"),
      },
    ],
  },
];